module.exports = __webpack_public_path__ + "5c177d4cb401a861857094f0e2581aac.svg";